import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Storage } from '../../context-discovery-services/models';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class HistoryValidationService {

  organizationId: string;
  _api_url: string;
  constructor(private apiService: ApiService) {
    this.organizationId = sessionStorage.getItem('organizationid');
    this._api_url = environment.historyValidation.historyValidationServiceUrl;
  }

  getStorageInfo(): Observable<Storage> {
    return this.apiService.get('organizations/' + this.organizationId + '/writesastoken', this._api_url);
  }

  validateHistoryZip(): Observable<any> {
    return this.apiService.post('organizations/' + this.organizationId + '/validate', this._api_url);
  }

  getValidateHistoryStatus(): Observable<any> {
    return this.apiService.get('organizations/' + this.organizationId + '/validationstatus', this._api_url);
  }

  getPointsWithMissingHistory(): Observable<Array<string>> {
    return this.apiService.get('organizations/' + this.organizationId + '/pointsWithMissingHistory', this._api_url);
  }

  putFileUploadCompleted() {
    return this.apiService.put('organizations/' + this.organizationId + '/fileupload',
      this._api_url);
  }

  getHistoryFileName(): Observable<any> {
    return this.apiService.get('organizations/' + this.organizationId + '/fileupload', this._api_url);
  }

}
